// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/Content/ProviderCount/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_Connection_Content_ProviderCount($location_id: uuid!, $connection_id: uuid!) {
  vaxiom_employee_resources(
    where: {
      resource: {
        organization: { _id: { _eq: $location_id } }
        resource_type: { is_provider: { _eq: true } }
      }
      employment_contract: { person: {} }
    }
  ) {
    id
    _id
    employment_contract {
      id
      person {
        id
        _id
        first_name
        last_name
      }
    }
    connection_providers(where: { connection_id: { _eq: $connection_id } }) {
      id
    }
  }
}

`